import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  location: "",
  dateRange: {
    startDate: moment(),
    endDate: moment().add(4, "days"),
  },
  guests: {
    guestAdults: 2,
    guestChildren: 2,
    guestInfants: 1,
  },
  //Selected Car
  selectedCar: null,
  selectedDate: null,
  // hoverId
  currentHoverID: -1,
  showModal: false,
  details: {},
};
// Create a new slice using the createSlice function:
const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setAll(state, action) {
      state.details = { ...action.payload };
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
    setDateRange(state, action) {
      const { startDate, endDate } = action.payload;
      state.dateRange = {
        startDate: startDate ? moment(startDate) : null,
        endDate: endDate ? moment(endDate) : null,
      };
    },
    setSingleDate(state, action) {
      const startDate = action.payload;
      state.selectedDate = startDate ? moment(startDate) : null;
    },

    setGuests(state, action) {
      state.guests = action.payload;
    },
    // Selected Car
    setSelectedCar(state, action) {
      state.selectedCar = action.payload;
    },
    // hoverId
    setCurrentHoverID(state, action) {
      state.currentHoverID = action.payload;
    },
    openModal(state) {
      state.showModal = true;
    },
    closeModal(state) {
      state.showModal = false;
    },
  },
});

//   Export the slice and its actions:

export const {
  setLocation,
  setDateRange,
  setGuests,
  setSelectedCar,
  setCurrentHoverID,
  openModal,
  closeModal,
  setSingleDate,
  setAll,
} = bookingSlice.actions;
export default bookingSlice.reducer;
